import { DataBean } from "../DataBean";

export class SalesTaxWithHoldingTax extends DataBean {

    public async getSalesTaxWithHoldingTaxTaxCatalog(idSalesOrder: number, salesOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesTaxWithHoldingTaxTaxCatalog_Number_java.util.Date", [idSalesOrder, salesOrderDate]);
    }

    public async parseTaxSchemaValuesWithHoldingTaxForSalesOrder(idSalesOrder: number, salesOrderDate: any, taxSchemeValueList: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "double_parseTaxSchemaValuesWithHoldingTaxForSalesOrder_Number_java.util.Date_java.util.List", [idSalesOrder, salesOrderDate, taxSchemeValueList]);
    }

    public async deleteSalesTaxWithHoldingTax(idSalesOrder: number, salesOrderDate: any, idSalesTaxWithHoldingTax: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSalesTaxWithHoldingTax_Number_java.util.Date_Number", [idSalesOrder, salesOrderDate, idSalesTaxWithHoldingTax]);
    }

}
